import { useParams } from "react-router-dom";
import styles from "./Post.styles";
import Hero from "./sections/Hero";
import Body from "./sections/Body";
import { useEffect, useState } from "react";
import * as contentful from "contentful";
import Seo from "../../components/Seo";
import { useI18n } from "../../i18n";

export default function Post() {
  const { slug } = useParams();
  const [post, setPost] = useState({});
  const [posts, setPosts] = useState({});
  const [loaded, setLoaded] = useState(false);
  const { t } = useI18n();

  useEffect(() => {
    const client = contentful.createClient({
      space: process.env.REACT_APP_CONTENTFUL_ID,
      accessToken: process.env.REACT_APP_CONTENTFUL_CDK,
    });

    client
      .getEntries({ content_type: "blog", order: "-fields.date" })
      .then(function (entries) {
        let items = entries?.items;

        if (entries) {
          setPosts(items);

          let found = Object.values(items).find((p) => p.fields.slug === slug);

          if (found) {
            setPost(found);
          }

          setLoaded(true);
        }
      });
  }, [slug]);

  return (
    <div className={`${styles.container}`}>
      <Seo
        type="article"
        title={
          loaded && post.fields?.title
            ? `${post.fields.title}${t("seo_post_suffix")}`
            : t("seo_blog_title")
        }
        description={post.fields?.description || t("seo_blog_desc")}
        image={
          post.fields?.image?.fields?.file?.url
            ? `https:${post.fields.image.fields.file.url}`
            : undefined
        }
        datePublished={post.fields?.date}
        slug={post.fields?.slug}
      />
      {loaded && Object.keys(post).length ? (
        <>
          <Hero post={post} />
          <Body post={post} posts={posts} />
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
